import { useEffect } from 'react';

const suppressObserverError = (): void => {
  const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
  const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
  if (resizeObserverErr) {
    resizeObserverErr.setAttribute('style', 'display: none');
  }
  if (resizeObserverErrDiv) {
    resizeObserverErrDiv.setAttribute('style', 'display: none');
  }
};

const useHideObserverErrors = (): void => {
  useEffect(() => {
    const hideError = (e: ErrorEvent): void => {
      if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        suppressObserverError();
      }
    };

    window.addEventListener('error', hideError);
    return () => {
      window.addEventListener('error', hideError);
    };
  }, []);
};

export default useHideObserverErrors;
